import * as Amplitude from "@amplitude/analytics-browser"

/**
 * User clicked on a share button.
 */
export function sharePostClicked(postId: string, shareType: string) {
  return Amplitude.track("share_post_click", {
    post_id: postId,
    source: "publish_success_modal",
    share_type: shareType,
  })
}

/**
 * User clicked on view post from publish success modal.
 */
export function viewPostFromPublishSuccessModalClicked(postId: string) {
  return Amplitude.track("view_post_clicked", {
    post_id: postId,
  })
}
